/**
 * Composable de feature-gating par lot.
 * Basé sur la variable d'environnement VITE_MAX_LOT (ex: "LOT5") injectée
 * par le pipeline GitLab CI/CD selon le centre déployé.
 *
 * Convention : les lots sont ordonnés LOT1 < LOT2 < ... < LOT9.
 * VITE_MAX_LOT="LOT5" donne accès à LOT1, LOT2, LOT3, LOT4, LOT5.
 *
 * Comportement :
 * - Synelia develop/staging : pas de contrôle (tout accessible pour tester)
 * - Centres develop/staging/production : VITE_MAX_LOT requis, sinon LOT1 uniquement
 * - Synelia production : VITE_MAX_LOT requis, sinon LOT1 uniquement
 */

const MAX_LOT = import.meta.env.VITE_MAX_LOT as string | undefined;
const ENV_NAME = import.meta.env.VITE_ENVNAME as string | undefined;
const CENTER_NAME = import.meta.env.VITE_CENTERNAME as string | undefined;

const IS_SYNELIA_NON_PROD = CENTER_NAME?.toUpperCase() === "SYNELIA"
    && ENV_NAME?.toUpperCase() !== "PRODUCTION";

function lotNumber(lot: string): number {
    const match = lot.match(/^LOT(\d+)$/i);
    return match ? parseInt(match[1], 10) : 0;
}

const maxLotNumber = IS_SYNELIA_NON_PROD
    ? Infinity
    : (MAX_LOT ? lotNumber(MAX_LOT) : 0);

export function useFeatureLot() {

    /** Vérifie si un lot est accessible sur cette instance */
    function hasLot(lot: string): boolean {
        return lotNumber(lot) <= maxLotNumber;
    }

    /** Vérifie si une route est accessible (si meta.lot est défini) */
    function canAccessRoute(meta: Record<string, any>): boolean {
        if (!meta?.lot) return true;
        return hasLot(meta.lot);
    }

    return { hasLot, canAccessRoute, maxLotNumber };
}
